module.exports = {"id":"221875","name":"Son Jun Ho","rating":"72","photo":"./data/images/photos/0/221875.png","club":{"name":"Jeonbuk Hyundai","logo":"./data/images/clubs/JeonbukHyundai.png"},"positions":["MC","MDC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SonJunHo0.json
// module id = 3992
// module chunks = 0